import styled from "styled-components";

import { AutocompleteItemWrapper } from "@similarweb/ui-components";

export const StyledAutocompleteCompanyWrapper = styled(AutocompleteItemWrapper)`
    padding: 8px 16px;

    &:first-child {
        margin-top: 8px;
    }

    &:last-child {
        margin-bottom: 8px;
    }
`;
